module.exports = __webpack_public_path__ + "static/logo-567c2e9fb15c040e552e53495a7de228.png";